<template>
  <div class="range-wrap">
    <input 
			ref="range"
      type="range" 
      class="range"
			v-model="rangeValue" 
      :min="min" 
      :max="max"
			@input="updateSlider"
			:disabled="disabled"
      >
    <output ref="bubble" class="bubble"></output>
  </div>
</template>

<script>
	import { ref, onMounted } from 'vue'

	export default {
		name: 'range',
		props: {
			value: {
        type:Number,
        default: 0
			},
      min: {
        type:Number,
        default: 0
      },
      max: {
        type:Number,
        defeault: 100
      },
      disabled: {
        type:Boolean,
        defeault: false
      },
			customLabel: {
				type: Function
			}
		},
    setup(props) {
			const range = ref(null);
			const bubble = ref(null);
			const rangeValue = ref(props.value);

			onMounted(() => {
				setBubble(range.value, bubble.value);
			});

			function updateSlider() {
				setBubble(range.value, bubble.value);
			}

      function setBubble(range, bubble) {
        const val = rangeValue.value;
        const min = range.min ? range.min : 0;
        const max = range.max ? range.max : 100;
        const newVal = Number(((val - min) * 100) / (max - min));
        bubble.innerHTML = val;

        // Sorta magic numbers based on size of the native UI thumb
        bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;

				if(props.customLabel) {
					bubble.innerHTML = props.customLabel;
				}
      }

			return {
				range,
				bubble,
				updateSlider,
				rangeValue
			}
    }
	}
</script>

<style lang="scss">
	.range-wrap {
    position: relative;
    margin: 0 auto 3rem;
  }
  .range {
    width: 100%;

    option {
      font-weight: bold;
      font-size: .9em;
      margin-top: -5px;
    }
  }
  .bubble {
    background: #00DEB2;
    // background: linear-gradient(111.26deg, #00DEB2 30.35%, #D2FCCD 106.9%);
    color: #28006D;
    padding: 6px 20px 0px;
    position: absolute;
    border-radius: 4px;
		top: 50px;
    left: 50%;
    transform: translateX(-50%);
    font-family: $font-header;
    font-size: 1.4em;
  }
  .bubble::after {
      content: " ";
      width: 0;
      height: 0;
      
      border-style: solid;
      border-width: 40px 12.5px 0 12.5px;
      border-color: #00DEB2 transparent transparent transparent;

      position: absolute;
      top: -38px;
      left: 50%;
      transform: rotate(-180deg) translateX(50%);
  }
</style>